import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFingerReason } from "src/models/Maintenance/FingerReason.models";

interface FingerReasonState {
  fingerReasons: IFingerReason[];
  fingerReasonToEdit: IFingerReason | null;
}

const initialState: FingerReasonState = {
  fingerReasons: [],
  fingerReasonToEdit: null,
};

const fingerReasonSlice = createSlice({
  name: "FingerReason",
  initialState,
  reducers: {
    setFingerReasonList: (state, action: PayloadAction<IFingerReason[]>) => {
      state.fingerReasons = action.payload;
    },
    concatListFingerReason: (state: FingerReasonState, action: PayloadAction<IFingerReason[]>) => {
      state.fingerReasons = [...state.fingerReasons.concat(action.payload)];
    },
    setFingerReasonToEdit: (state, action: PayloadAction<IFingerReason | null>) => {
      state.fingerReasonToEdit = action.payload;
    },
    addFingerReason: (state, action: PayloadAction<IFingerReason>) => {
      state.fingerReasons.push(action.payload);
    },
    updateFingerReason: (state, action: PayloadAction<IFingerReason>) => {
      let itemIndex = state.fingerReasons.findIndex(
        item => item.fingerReasonId === action.payload.fingerReasonId
      );
      if (itemIndex !== -1) state.fingerReasons[itemIndex] = action.payload;
    },
    deleteFingerReason: (state, action: PayloadAction<number>) => {
      const newArray = state.fingerReasons.filter(
        item => item.fingerReasonId !== action.payload
      );
      state.fingerReasons = newArray;
    },
  },
});

export const {
  setFingerReasonList,
  concatListFingerReason,
  setFingerReasonToEdit,
  addFingerReason,
  updateFingerReason,
  deleteFingerReason,
} = fingerReasonSlice.actions;

export default fingerReasonSlice.reducer;
